import { FC } from "react";
import FlexBox from "../common/flex-box";
import SimpleCard from "../common/simple-card";
import SimpleDataTable from "../common/simple-data-table";
import { CLINIC_WORKING_HOURS_COLUMNS } from "lib/constants/table-columns";
import { DEFAULT_WORKING_HOURS } from "lib/constants";
import SimpleCalendar from "../common/calendar/simple-calendar";
import { Image } from "react-bootstrap";
import { ASSETS } from "assets";

interface ClinicPreviewProps {
  clinic: Clinic;
  clinicCalendar: CalendarDetails;
  unavailableDays: UnavailableDay[];
  clinicWorkingHours: WorkingHour[];
  clinicProfilePicUrl?: string;
  holidays: Date[];
  bookedDays: Date[];
  isShowCalendar?: boolean;
  isShowWorkingHours?: boolean;
  isShowShadow?: boolean;
}

const ClinicPreview: FC<ClinicPreviewProps> = ({
  clinic,
  clinicCalendar,
  clinicWorkingHours,
  unavailableDays,
  clinicProfilePicUrl,
  holidays,
  bookedDays,
  isShowCalendar = true,
  isShowWorkingHours = true,
  isShowShadow = true,
}) => {
  return (
    <SimpleCard className={`${isShowShadow ? "shadow" : ""}`}>
      <FlexBox justifyContent="between" alignItems="center">
        <Image
          src={clinicProfilePicUrl ?? ASSETS.IMAGES.IMG_LONDON}
          width={130}
          style={{ borderRadius: "10px" }}
        />
        <div className="text-end">
          <h4 className="ml-2">{clinic?.name}</h4>
          <p className="m-0">{clinic?.address}</p>
        </div>
      </FlexBox>
      <hr />
      <div className="pb-2">
        <strong>Clinic Working Hours</strong>
      </div>
      {isShowWorkingHours && (
        <SimpleDataTable
          //className="mt-3"
          columns={CLINIC_WORKING_HOURS_COLUMNS}
          data={
            clinicWorkingHours?.length === 0
              ? DEFAULT_WORKING_HOURS
              : clinicWorkingHours
          }
          isShowPagination={false}
        />
      )}
      {isShowCalendar && (
        <>
          <div className="py-2">
            <strong>Clinic Calendar</strong>
          </div>
          <FlexBox justifyContent="center">
            <SimpleCalendar unavailableDays={unavailableDays} />
          </FlexBox>
        </>
      )}
    </SimpleCard>
  );
};

export default ClinicPreview;
